import React, { FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './centered-button.module.scss'

interface CenteredButtonProps extends HTMLAttributes<HTMLDivElement> {
  noMargin?: boolean
}

export const CenteredButton: FC<CenteredButtonProps> = ({
  noMargin,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      classes.centeredButton,
      { [classes.noMargin]: noMargin },
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

export default CenteredButton
